import ExcelJS from "exceljs";
import FileSaver from "file-saver";
import {jy_request_common, tcm_api_prefix, isDEV, dict2params} from "./request";

export let prefix = '';
let {protocol} = window.location;
let gptURL =  (isDEV? 'https://llm.drai.cn': tcm_api_prefix) + '/chatgpt/';
// gptURL =  (tcm_api_prefix) + '/chatgpt/';
// https://aicloud.conestore.cn:30013/qwen-back/v1
// http://mlops.ccloud.conestore.cn:30010/webglm-back/v1
let mlopsURL = 'http://mlops.ccloud.conestore.cn:30010/webglm-back/v1';
if(protocol.startsWith('https')) mlopsURL = 'https://aicloud.conestore.cn:30013/qwen-back/v1';
export let endSign = '<|endoftext|>';
export let getAccount = ()=> localStorage.getItem('account');
export let isLogin = ()=>{
  let account = getAccount();
  let is = !!account;
  console.log('isLogin', is, account);
  return is;
};
export let goToLogin = ()=>{
  if(!isLogin()) window.location.href = '/login/';
};
export const postBaiduTranslate = async (to, q, func)=>{
  // console.log(rq);
  goToLogin();
  jy_request_common({
    crud_name: '百度翻译',
    base_url: '/baidu/texttrans/',
    url: '',
    type: 'post',
    data: {
      "from": "auto",
      "to": to,
      "q": q
    },
    success: (res)=>{
      // func(res);
      let {result} = res;
      let {trans_result} = result;
      trans_result = trans_result || [];
      let dst = trans_result.map(t=>t.dst);
      func(dst.join('\n'));
    },
    fail: (err)=>{
      // this.handleSubmitGPT(rq);
      console.log(err);
    }
  });


};
export const downloadTextItems = (textItems)=>{
  textItems = textItems || [];
  let fileName = '会话记录';
  let index = 0;
  // 创建工作簿
  const workbook = new ExcelJS.Workbook();
  // 添加工作表，名为sheet1
  const sheet1 = workbook.addWorksheet("sheet1");

  fileName = fileName +('_' + new Date().toLocaleDateString());

  // 获取表头所有键
  // const headers = Object.keys(data[0]);
  // 将标题写入第一行
  // sheet1.addRow(headers);
  // 将数据写入工作表

  textItems.map((row, rIndex)=>{
    if(rIndex > 1){
      let {className, text, references} = row;
      if(className === 'textLeft'){
        if(text.startsWith(prefix)) text = text.substring(prefix.length);
        sheet1.addRow(['', prefix, text.trim()])
      } else {
        index ++;
        sheet1.addRow([index, 'Question: ', text.trim()]);
      }

      if(Array.isArray(references) && references.length > 0){
        sheet1.addRow(['', 'References:']);
        references.map((r, rIndex)=>{
          sheet1.addRow(['', '['+(rIndex+1)+']', r.title, r.text, r.url])
        })
      }
    }
  });
  // 导出表格文件
  workbook.xlsx.writeBuffer().then((buffer) => {
    let file = new Blob([buffer], {type: "application/octet-stream"});
    FileSaver.saveAs(file, fileName + ".xlsx");
  }).catch(error => console.log('Error writing excel export', error));
};
export const downloadExcel = (fileName, textItems) =>{
  textItems = textItems || [];
  // 创建工作簿
  const workbook = new ExcelJS.Workbook();
  // 添加工作表，名为sheet1
  const sheet1 = workbook.addWorksheet("sheet1");

  fileName = fileName +('_' + new Date().toLocaleDateString());

  // 获取表头所有键
  // const headers = Object.keys(data[0]);
  // 将标题写入第一行
  // sheet1.addRow(headers);
  // 将数据写入工作表

  textItems.map((row, rIndex)=>{
    if(typeof row === 'object'){
      let keys = Object.keys(row);
      if(rIndex === 0) sheet1.addRow(keys);
      sheet1.addRow(keys.map(k=>row[k]));
    } else sheet1.addRow(row);
  });
  // 导出表格文件
  workbook.xlsx.writeBuffer().then((buffer) => {
    let file = new Blob([buffer], {type: "application/octet-stream"});
    FileSaver.saveAs(file, fileName + ".xlsx");
  }).catch(error => console.log('Error writing excel export', error));
};
let v3 = 'gpt-3.5-turbo';
let v4 = 'gpt-4-vision-preview';
export const postGPT= (rq, func, model=v3)=>{
  // goToLogin();
  let {question, stream, src, model: gptModal} = rq;
  stream = false;
  model = src? v4: (gptModal || model || v3);
  let content = model === v3? question: [
    // ...textItems.filter,
    {
      "type": "text",
      "text": question
    }
  ];
  if(src){
    content = [
      ...content,
      {
        "type": "image_url",
        "image_url": {
          "url": src
        }
      }
    ]
  }
  let data = {
    model,
    messages: [
      {role: 'user', content}
    ],
    max_tokens: 1000,
    stream
  };
  if(stream) getGPTStream(data, func);
  else jy_request_common({
    crud_name: 'GPT回复',
    data,
    base_url: gptURL,
    url: '',
    type: 'post',
    success: (result)=>{
      let {choices, message} = result;
      console.log('response', choices);
      choices = choices || [];
      let answer = choices.map(c=>c.message.content).join('\n');
      console.log('answer', answer);
      if(func) func(answer || message);
    }
  });
};

export const getGPTStream = async (data, func)=>{
  // console.log(rq);
  var source = new EventSource(gptURL);
  let n  = 0;
  source.onmessage = function(event) {
    const jsonData = JSON.parse(event.data);
    // let respondTexts = jsonData.delta;
    // let finishStatus = jsonData.finished
    // console.log('----', jsonData);
    if (jsonData) {
      let {choices} = jsonData;
      choices = choices || [];
      let answer = choices.map(c=>{
        return c.delta.content
      });
      // 答案输出是流式的，有多次返回
      // 遇到终止符时关闭sse连接
      console.log(n, 'xxx', answer);
      if(func) func(data.question, answer.join(''), [], n);
      n ++;
    }
  };
  source.onerror = function(error) {
    // Handle error
    console.log(error);
    func('INTERNAL SERVER ERROR' + endSign)
  };

};
export const getMLOPS = (data, func)=>{
  goToLogin();
  let {stream, question, search, keywords} = data;
  let rq = {question};
  let apiName = 'sse';
  if(search) rq = {...rq, search};
  if(!keywords) {console.log(rq)}
  else {
    rq = {...rq, keywords, search: 'mix'};
    apiName = 'sse2';
  }
  if(stream) getMlopsStream(rq, func, apiName);
  else jy_request_common({
    crud_name: 'mlops回复',
    data: rq,
    base_url: mlopsURL + '/ask',
    url: '',
    type: 'get',
    success: (res)=>{
      let {response} = res;
      console.log('response', response);
      let {answer, references} = response;
      if(func) func(answer, references);
    },
    fail: (err)=>{
      console.log(err);
      func('error');
    }
  });
};
export const getMlopsStream = async (data, func, apiName='sse')=>{
  // console.log(rq);
  let url = mlopsURL + '/'+apiName+'?' + dict2params(data);
  var source = new EventSource(url);
  let references = [];
  let n  = 0;
  source.onmessage = function(event) {
    const eventData = event.data;
    const parsedData = JSON.parse(eventData);
    // console.log(postData);
    if (parsedData.url) {
      references = [...references, parsedData];
      console.log('References:', references);
    }

    if (parsedData.answer) {
      const answer = parsedData.answer;
      // 答案输出是流式的，有多次返回
      // 遇到终止符时关闭sse连接
      if (answer.includes(endSign)){
        source.close();
      }
      if(func) func(answer, references, n);
      n ++;
    }
  };
  source.onerror = function(error) {
    // Handle error
    console.log(error);
    func('INTERNAL SERVER ERROR' + endSign);
    source.close();
  };
};
export const postBidTask = (data, func)=>{
  jy_request_common({
    crud_name: '生成标书',
    data,
    base_url: '/bid/',
    url: '',
    type: 'post',
    success: func
  });
};
export const putBidContent = (data, func)=>{
  jy_request_common({
    crud_name: '更新标书内容',
    data,
    base_url: '/bid/',
    url: '',
    type: 'put',
    success: func
  });
};
export const getBidContent = (data, func)=>{
  jy_request_common({
    crud_name: '获取标书内容',
    data,
    base_url: '/bid/',
    url: '',
    type: 'get',
    success: func
  });
};
export const deleteBid = (data, func)=>{
  jy_request_common({
    crud_name: '删除标书',
    data,
    base_url: '/bid/',
    url: '',
    type: 'delete',
    success: func
  });
};
export const isMobile = () => {
  var sUserAgent = navigator.userAgent.toLowerCase();
  var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
  var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
  var bIsMidp = sUserAgent.match(/midp/i) == "midp";
  var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
  var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
  var bIsAndroid = sUserAgent.match(/android/i) == "android";
  var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
  var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
  if (
    bIsIpad ||
    bIsIphoneOs ||
    bIsMidp ||
    bIsUc7 ||
    bIsUc ||
    bIsAndroid ||
    bIsCE ||
    bIsWM
  ) {
    console.log("手机登录");
    return true
  }
  return false;
};

// });


// 计算过去n天内的日期
export const dateWithinDays = (day, date) => {
    // date 是时间戳，秒
    const now = new Date();
    const diff = now - date;
    return diff < day * 24 * 60 * 60 * 1000; // 7天*24小时*60分钟*60秒*1000毫秒
};


export const isPhone = isMobile();
